<script lang="ts">
    import type {CapabilityOnBuildings, Department} from 'typings/portaro.be.types';
    import {exists} from 'shared/utils/custom-utils';

    export let capability: CapabilityOnBuildings;
    export let building: Department;
</script>


{#if capability.buildings.length === 1}
    <div class="loan-request-option-desired-building">
        {#if exists($$slots.default)}
            <slot/>
        {/if}
        <strong>{building.text}</strong>
    </div>
{/if}